module.exports = __webpack_public_path__ + "img/release.2edc4ce3.png";